module.exports = __webpack_public_path__ + "img/menu4.0d71dd6d.png";